import keyBy from "lodash.keyby"
import { useState, useEffect, useMemo } from "react"
import { useAppContext } from "@components/AppContext"

import hasAccess from "@api/hasAccess"

// const indexFundsOperation = "organizations/IndexPartnerOrganizations"
const indexSponsorsOperation = "backstage/IndexSponsors"


const usePartnersStore = () => {
  const { request, identity } = useAppContext()
  const { id: organizationId } = identity.organization

  // const [ funds, setFunds ] = useState()
  // const [ fundsMap, setFundsMap ] = useState()
  const [ sponsors, setSponsors ] = useState()

  let isInProgress = false
  useEffect(() => {
    if (isInProgress) { return }
    isInProgress = true

    Promise.all([
      // indexFunds(),
      indexSponsors(),
    ])

  }, [ organizationId ])

  const sponsorsMap = useMemo(() =>
    keyBy(sponsors, "id")
  , [ sponsors, organizationId ])

  // const customSetFunds = items => {
  //   const itemsMap = keyBy(items, "id")

  //   setFundsMap(itemsMap)
  //   setFunds(items)
  // }

  // const canAccessFunds = hasAccess(['partners-read'])
  const canAccessSponsors = hasAccess(['sponsors-read'])

  const indexSponsors = () =>
    canAccessSponsors
      ? request(indexSponsorsOperation )
          .then(({ data }) => setSponsors(data))
      : setSponsors([])

  // const indexFunds = () =>
  //   canAccessFunds
  //     ? request(indexFundsOperation )
  //         .then(({ data }) => customSetFunds(data))
  //     : customSetFunds([])

  const updateSponsor = updatedItem =>
    setSponsors((prevItems = []) =>
      prevItems.map(item => ({
        ...(item.id === updatedItem.id ? updatedItem : item)
      }))
    )

  const addSponsor = newItem =>
    setSponsors(prevItems => [ ...prevItems, newItem ])

  const deleteSponsor = id =>
    setSponsors(prevItems => [
      ...prevItems.filter(item => item.id !== id)
    ])

  const funds = []
  const fundsMap = {}

  const hasMultipleSponsors = useMemo(() =>
    (sponsors || []).length > 1
  , [ sponsors ])

  const getSponsorName = id =>
    sponsorsMap[id]
      ? sponsorsMap[id].name
      : id

  return {
    funds,
    fundsMap,
    sponsors,
    addSponsor,
    sponsorsMap,
    deleteSponsor,
    updateSponsor,
    indexSponsors,
    getSponsorName,
    hasMultipleSponsors,
  }
}

export default usePartnersStore
